export default __webpack_public_path__ + "static/media/qrInstallation.058ef2a5.svg";